<div
  class="criteo-video-product-card hmf-display-flex hmf-flex-row hmf-justify-content-center hmf-w-100 hmf-m-auto">
  <div class="criteo-video-product-card-image-col hmf-mr-xxs">
    <div class="criteo-video-product-card-image-container">
      <hmf-product-image
        class="criteo-video-product-card-image-wrapper hmf-pb-xxs hmf-my-0 hmf-mx-auto"
        [ecode]="product().ecode"
        [imageData]="product().imageData"
        [productName]="product().productName" />
    </div>
  </div>

  <div
    class="criteo-video-product-card-content hmf-display-flex hmf-flex-column hmf-justify-content-center hmf-gap-s">
    <div>
      <p class="criteo-video-product-card-name hmf-mt-0 hmf-mb-xxs hmf-body-m hmf-overflow-hidden">
        {{ product().productName }}
      </p>

      @if (!product().pricing.isHidden) {
        <hmf-price
          class="criteo-video-product-card-prices hmf-pb-xxs hmf-body-bold-l"
          [prices]="product().pricing.prices"
          [isClearance]="product().pricing.isClearance || false"
          [isSeePriceInCart]="product().pricing.isSeePriceInCart || false"
          [variant]="'wrapped'" />
      }

      @if (product().starRatings?.showCustomerRating) {
        <hmf-star-ratings
          class="criteo-video-product-card-star-ratings hmf-pb-xs"
          [ratingCount]="product().starRatings?.ratingCount ?? 0"
          [ratingValue]="truncatedRatingValue()"
          [showRating]="true"
          [showReviewCount]="false" />
      }
    </div>

    <div class="hmf-display-flex">
      <button
        hmf-button
        class="criteo-video-product-card-atc-button hmf-px-xxs hmf-pt-xxs hmf-pb-xxs hmf-w-100"
        [variant]="'secondary'"
        [text]="'Add to cart'"
        [size]="'medium'"
        [attr.aria-label]="'Add to cart'"
        [icon]="'order-cart-fill'"
        [iconSize]="'large'"
        (click)="onAddToCartClick($event)"></button>
    </div>
  </div>
</div>
